import type { PrintZone } from "@/components/print/DocumentPreview";
import type { PrintScope } from "../printLayoutForm";
import type { ImageUploader } from "../useImageUpload";
import { FontColorPanel } from "./FontColorPanel";
import { FooterPanel } from "./FooterPanel";
import { HeaderPanel } from "./HeaderPanel";
import { PaperPanel } from "./PaperPanel";
import { SignaturePanel } from "./SignaturePanel";

type Props = {
  zone: PrintZone;
  images: ImageUploader;
  onPreviewDigital: () => void;
  scope: PrintScope;
  variant?: "desktop" | "mobile";
};

export function AreaPanel({ zone, images, onPreviewDigital, scope, variant = "desktop" }: Props) {
  switch (zone) {
    case "page":
      return <PaperPanel images={images} />;
    case "header":
      return <HeaderPanel images={images} variant={variant} />;
    case "sign":
      return <SignaturePanel onPreviewDigital={onPreviewDigital} scope={scope} />;
    case "footer":
      return <FooterPanel variant={variant} />;
    case "body":
    default:
      return <FontColorPanel variant={variant} />;
  }
}
